import {Injectable} from '@angular/core';
import {WsLegalPensionStatus, WsRef} from '@lifeislife/lifeislife-ws-api';
import {RequestService} from '../../../service/request.service';
import {CachedWsResourceClient} from '../../../private_util/client/cached-http-ws-Resource-client';
import {AuthProvider} from '../../../domain/auth/auth-provider';
import {AppConfigService} from '../../../../service/config/app-config.service';
import {ResourceCacheService} from '../../../../util/cache/resource-cache.service';
import {FrontendResourceType} from '../../../../util/cache/cache-resource-type';

@Injectable({
  providedIn: 'root',
})
export class LegalPensionStatusWsClient extends CachedWsResourceClient<WsLegalPensionStatus, WsRef<WsLegalPensionStatus>> {

  constructor(
    private injectedRequestService: RequestService,
    private injectedAuthService: AuthProvider,
    private injectectedCacheService: ResourceCacheService,
    private injectedAppConfigService: AppConfigService,
  ) {
    super('/front/legalPensionStatus', injectedAppConfigService, injectedRequestService, injectedAuthService,
      FrontendResourceType.LEGAL_PENSION_STATUS, injectectedCacheService);
  }

}
